module.exports = __webpack_public_path__ + "static/media/main idea.ec9ba230.mp3";